import React, { useState, useEffect } from "react";
import clsx from "clsx";
import {
  Box,
  Card,
  Grid,
  makeStyles,
  FormControl,
  TextField,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormLabel,
  Button,
  Typography,
} from "@material-ui/core";
import SaveIcon from "@material-ui/icons/Save";
import { DropzoneArea } from "material-ui-dropzone";
import { NavLink as RouterLink } from "react-router-dom";
import { useParams } from "react-router";
import { useForm, Controller } from "react-hook-form";
import {
  apiEndpoints,
  apiPostCustomTimeoutRequest,
  apiGetByIdRequest,
  apiDownloadFileData,
  apiPutRequest,
} from "src/utils/api/api";
import { toContentBase64 } from "src/utils/utils";
import { useNavigate } from "react-router-dom";
import actions from "src/duck/global/actions";
import { connect } from "react-redux";
import { FileIcon, defaultStyles } from "react-file-icon";
import SvgIcon from "@material-ui/core/SvgIcon";
import Skeleton from "@material-ui/lab/Skeleton";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import fileDownload from "js-file-download";
import { kmMessages } from "src/constant/Messages";
import { decode } from "js-base64";
import { fillMissingTags } from "src/utils/utils";
import Accordion from "@material-ui/core/Accordion";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import UserAndDate from "src/components/common/UserAndDate";
import Switch from "@material-ui/core/Switch";

const nameMaxLength = 150;
const descriptionMaxLength = 500;

const formValidation = {
  required: kmMessages.error.form_validation.field_required,
  maxLength: `${kmMessages.error.form_validation.field_maxlengthnum}`,
};

const useStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      margin: theme.spacing(2),
    },
  },
  formcontrol: {
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(2),
  },
  paddingbottom: {
    paddingBottom: theme.spacing(1),
  },
  paddingtop: {
    paddingTop: theme.spacing(2),
  },
  button: {
    margin: theme.spacing(1),
  },
  fileicon: {
    fontSize: "2.7rem",
    marginTop: theme.spacing(2),
  },
  filename: {
    margin: theme.spacing(1),
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: "33.33%",
    flexShrink: 0,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
}));

const DocumentForm = ({
  setLogoutUser,
  enableGlobalLoader,
  disableGlobalLoader,
  displaySnackbar,
  document,
  editMode,
  ...rest
}) => {
  const classes = useStyles();
  const { parentFolderId } = useParams();
  const { documentId } = useParams();
  const { siblingDocumentId } = useParams();
  const { siblingDocumentName } = useParams();
  const [documentFile, setDocumentFile] = useState(null);
  const [documentName, setDocumentName] = useState();
  const navigate = useNavigate();
  const [saving, setSaving] = useState();
  const [documentData, setDocumentData] = useState();
  const [selectedAccess, setSelectedAccess] = useState("afterlogin");
  const [expanded, setExpanded] = useState(false);
  const [visibleVersions, setVisibleVersions] = useState(null);

  const { handleSubmit, setValue, control, errors } = useForm();

  useEffect(() => {
    if (editMode) {
      enableGlobalLoader();
      apiGetByIdRequest(apiEndpoints.getDocumentDetails.path, documentId, true)
        .then((data) => {
          disableGlobalLoader();
          setValue("name", data.name);
          setValue("description", data.versions[0].description);
          setValue("access", data.publicAccess ? "public" : "afterlogin");
          setSelectedAccess(data.publicAccess ? "public" : "afterlogin");
          setDocumentData(data);
          let versionsVisibility = data.versions.reduce((acc, version) => {
            acc[version.id] = version.visibility;
            return acc;
          }, {});
          console.log(versionsVisibility);
          setVisibleVersions(versionsVisibility);
        })
        .catch((error) => {
          disableGlobalLoader();
          if (error.response) {
            if (error.response.status === 403) {
              navigate("/nieuprawnionydostep");
            } else if (error.response.status === 401) {
              navigate("/logowanie");
            }
          }
        });
    }
    return () => {};
  }, []);

  useEffect(() => {
    setTimeout(fillMissingTags(), 1000);
    return () => {};
  }, []);

  const handleDocumentNameChange = (event) => {
    setDocumentName(event.target.value);
  };

  const handleFileUpload = (files) => {
    if (files.length > 0) {
      setDocumentFile(files[0]);
    } else {
      setDocumentFile(null);
    }
  };

  const handleToggleVisibility = (documentId) => {
    setVisibleVersions((prevState) => ({
      ...prevState,
      [documentId]: !prevState[documentId],
    }));
    console.log(visibleVersions);
  };

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const onSubmit = (values) => {
    if (editMode) {
      enableGlobalLoader();
      setSaving(true);
      console.log(visibleVersions);

      toContentBase64(documentFile).then((fileContent) => {
        apiPutRequest(
          apiEndpoints.updateDocument.path,
          {
            id: documentData.versions[0].id,
            name: values.name,
            description: values.description,
            fileName: documentFile ? documentFile.name : null,
            fileContent: documentFile ? fileContent : null,
            position: values.position,
            publicAccess: values.access === "public" ? true : false,
            siblingId: siblingDocumentId,
            versionsVisibility: visibleVersions,
          },
          true
        )
          .then((data) => {
            disableGlobalLoader();
            if (documentData.parentFolderId) {
              navigate("/dokumenty/" + documentData.parentFolderId);
            } else {
              navigate("/dokumenty");
            }
          })
          .catch((error) => {
            disableGlobalLoader();
            if (error.response && error.response.status === 401) {
              setLogoutUser();
            } else {
              handleDocumentError(error);
            }
          });
      });
    } else {
      if (documentFile) {
        enableGlobalLoader();
        setSaving(true);
        toContentBase64(documentFile).then((fileContent) => {
          apiPostCustomTimeoutRequest(
            apiEndpoints.addDocument.path,
            {
              parentId: parentFolderId,
              name: values.name,
              description: values.description,
              fileName: documentFile.name,
              fileContent: fileContent,
              position: values.position,
              publicAccess: values.access === "public" ? true : false,
              siblingId: siblingDocumentId,
            },
            true,360000
          )
            .then((data) => {
              disableGlobalLoader();
              setSaving(false);

              if (parentFolderId) {
                navigate("/dokumenty/" + parentFolderId);
              } else {
                navigate("/dokumenty");
              }
            })
            .catch((error) => {
              disableGlobalLoader();
              setSaving(false);
              if (error.response && error.response.status === 401) {
                setLogoutUser();
              } else {
                handleDocumentError(error);
              }
            });
        });
      } else {
        displaySnackbar({
          isOpen: true,
          severity: "error",
          autoHideDuration: 6000,
          message: kmMessages.error.document.file_not_selected,
        });
      }
    }
  };

  const handleDocumentError = (error) => {
    if (
      error.response.status === 403 &&
      error.response.data &&
      error.response.data.code === "ERROR_NOT_PUBLIC_ACCESS_PARENT"
    ) {
      displaySnackbar({
        isOpen: true,
        severity: "error",
        autoHideDuration: 8000,
        message:
          "Katalog nadrzędny nie jest dostępny publicznie. Dodawany/edytowany dokument nie może mieć dostępu publicznego.",
      });
    } else {
      displaySnackbar({
        isOpen: true,
        severity: "error",
        autoHideDuration: 8000,
        message: kmMessages.error.global.genericerror,
      });
    }
  };

  const handleFileDownload = (documentDetailsId, filename) => {
    apiDownloadFileData(
      `${apiEndpoints.documentFileData.path}${documentDetailsId}`,
      true
    ).then((result) => {
      fileDownload(result, filename);
    });
  };

  return (
    <Card className={clsx(classes.root)} {...rest}>
      <Box component="main">
        <Grid container className={classes.root}>
          <Grid item xs={12} elevation={2}>
            <form onSubmit={handleSubmit(onSubmit)}>
              <FormControl fullWidth className={classes.formcontrol}>
                <Controller
                  as={
                    <TextField
                      error={errors.name ? true : false}
                      id="name"
                      name="name"
                      label="Nazwa"
                      type="text"
                      onChange={handleDocumentNameChange}
                      helperText={
                        errors.name &&
                        (formValidation[errors.name.type] || "").replaceAll(
                          "{maxlen}",
                          nameMaxLength
                        )
                      }
                    />
                  }
                  name="name"
                  defaultValue=""
                  control={control}
                  rules={{ required: true, maxLength: nameMaxLength }}
                />
              </FormControl>
              <FormControl fullWidth className={classes.formcontrol}>
                <Controller
                  as={
                    <TextField
                      error={errors.description ? true : false}
                      id="description"
                      name="description"
                      label="Opis"
                      placeholder="Opis"
                      multiline
                      helperText={
                        errors.description &&
                        (
                          formValidation[errors.description.type] || ""
                        ).replaceAll("{maxlen}", descriptionMaxLength)
                      }
                    />
                  }
                  name="description"
                  defaultValue=""
                  control={control}
                  rules={{ maxLength: descriptionMaxLength }}
                />
              </FormControl>
              {/* <FormControl
                  component="fieldset"
                  className={classes.formcontrol}
                  fullWidth
                >
                  <FormLabel component="legend">Dostęp:</FormLabel>
                  <Controller
                    as={
                      <RadioGroup
                        row
                        aria-label="Dostęp do katalogu"
                        name="access"
                      >
                        <FormControlLabel
                          value="afterlogin"
                          control={<Radio color="primary" />}
                          label="po zalogowaniu"
                        />
                        <FormControlLabel
                          value="public"
                          control={<Radio color="primary" />}
                          label="publiczny"
                        />
                      </RadioGroup>
                    }
                    name="access"
                    defaultValue={selectedAccess}
                    control={control}
                    rules={{ required: true }}
                  />
                </FormControl> */}
              {editMode ? (
                <Box>
                  <FormControl
                    component="fieldset"
                    className={classes.formcontrol}
                  >
                    <FormLabel component="legend">
                      Pozycja w katalogu:
                    </FormLabel>
                    <Controller
                      as={
                        <RadioGroup row aria-label="position" name="position">
                          <FormControlLabel
                            value="nochange"
                            control={<Radio color="primary" />}
                            label="bez zmian"
                          />
                          <FormControlLabel
                            value="start"
                            control={<Radio color="primary" />}
                            label="na początku"
                          />
                          <FormControlLabel
                            value="end"
                            control={<Radio color="primary" />}
                            label="na końcu"
                          />
                          {siblingDocumentId &&
                          siblingDocumentId != documentId ? (
                            <FormControlLabel
                              value="afterdoc"
                              control={<Radio color="primary" />}
                              label={
                                siblingDocumentName
                                  ? `za '${decode(siblingDocumentName)}'`
                                  : "za wskazanym"
                              }
                            />
                          ) : (
                            <></>
                          )}
                        </RadioGroup>
                      }
                      name="position"
                      defaultValue="nochange"
                      control={control}
                      rules={{ required: true }}
                    />
                  </FormControl>
                  {!documentData ? (
                    <Skeleton />
                  ) : (
                    <Box>
                      <SvgIcon className={classes.fileicon}>
                        <FileIcon
                          extension={documentData.versions[0].fileType}
                          {...defaultStyles[documentData.versions[0].fileType]}
                        />
                      </SvgIcon>
                      <Typography className={classes.filename} display="inline">
                        {documentData.versions[0].originalFileName}
                      </Typography>

                      <Button
                        variant="contained"
                        color="default"
                        className={classes.button}
                        startIcon={<CloudDownloadIcon />}
                        onClick={() =>
                          handleFileDownload(
                            documentData.versions[0].id,
                            documentData.versions[0].originalFileName
                          )
                        }
                      >
                        Pobierz plik
                      </Button>
                    </Box>
                  )}
                </Box>
              ) : (
                <FormControl
                  component="fieldset"
                  className={classes.formcontrol}
                >
                  <FormLabel component="legend">Pozycja w katalogu:</FormLabel>
                  <Controller
                    as={
                      <RadioGroup row aria-label="position" name="position">
                        <FormControlLabel
                          value="start"
                          control={<Radio color="primary" />}
                          label="na początku"
                        />
                        <FormControlLabel
                          value="end"
                          control={<Radio color="primary" />}
                          label="na końcu"
                        />
                        {siblingDocumentId ? (
                          <FormControlLabel
                            value="afterdoc"
                            control={<Radio color="primary" />}
                            label={
                              siblingDocumentName
                                ? `za '${decode(siblingDocumentName)}'`
                                : "za wskazanym"
                            }
                          />
                        ) : (
                          <></>
                        )}
                      </RadioGroup>
                    }
                    name="position"
                    defaultValue="end"
                    control={control}
                    rules={{ required: true }}
                  />
                </FormControl>
              )}
              <FormControl
                fullWidth
                className={classes.formcontrol}
                variant="outlined"
              >
                <Box className={classes.paddingbottom}>
                  <FormLabel for="docfileupload">Dodaj plik:</FormLabel>
                </Box>
                <DropzoneArea
                  name="fileupload"
                  className={classes.fileUpload}
                  onChange={handleFileUpload}
                  showPreviews={true}
                  showPreviewsInDropzone={false}
                  useChipsForPreview
                  maxFileSize={200 * 1024 * 1024}
                  filesLimit={1}
                  dropzoneText="Przeciągnij i upuść plik lub kliknij"
                  inputProps={{ title: "Dodaj plik", id: "docfileupload" }}
                  getFileAddedMessage={(fileName) =>
                    `Plik ${fileName} został załadowany.`
                  }
                  getFileRemovedMessage={(fileName) =>
                    `Plik ${fileName} został usunięty.`
                  }
                  getFileLimitExceedMessage={() =>
                    `Nie można załadować więcej niż 1 pliku.`
                  }
                  getDropRejectMessage={(maxFileSize) =>
                    `Przekroczono maksymalny rozmiar ładowanego pliku.`
                  }
                  previewGridProps={{
                    container: { spacing: 1, direction: "row" },
                  }}
                  previewChipProps={{
                    classes: { root: classes.previewChip },
                  }}
                />
              </FormControl>
              {editMode ? (
                <Box>
                  <FormControl
                    fullWidth
                    className={classes.formcontrol}
                    variant="outlined"
                  >
                    <FormLabel component="label">Wersje dokumentu</FormLabel>

                    {!documentData ? (
                      <Skeleton />
                    ) : (
                      documentData.versions.map((document, index) => (
                        <Accordion
                          key={document.id}
                          expanded={expanded === `panel${document.id}`}
                          onChange={handleChange(`panel${document.id}`)}
                          className={classes.accordion}
                        >
                          <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1bh-content"
                            id="panel1bh-header"
                          >
                            <Typography className={classes.heading}>
                              Wersja {document.versionNum} {visibleVersions
                                          && !visibleVersions[document.id] ? '(UKRYTA)' : ''}
                            </Typography>
                            <Typography className={classes.secondaryHeading}>
                              {document.originalFileName}
                            </Typography>
                          </AccordionSummary>
                          <AccordionDetails>
                            <Grid container spacing={3}>
                              <Grid item xs>
                                <FormLabel
                                  className={classes.paddingBottom}
                                  component="label"
                                >
                                  Nazwa dokumentu
                                </FormLabel>
                                <Typography>{document.name}</Typography>
                              </Grid>
                              <Grid item xs>
                                {index !== 0 ? (
                                  <>
                                    <FormLabel
                                      className={classes.paddingBottom}
                                      component="label"
                                    >
                                      Widoczność
                                    </FormLabel>
                                    <Switch
                                      checked={
                                        visibleVersions
                                          ? visibleVersions[document.id]
                                          : false
                                      }
                                      onChange={() =>
                                        handleToggleVisibility(document.id)
                                      }
                                    />
                                  </>
                                ) : (
                                  <></>
                                )}
                              </Grid>
                            </Grid>
                          </AccordionDetails>
                          <AccordionDetails>
                            <Grid container spacing={3}>
                              <Grid item xs>
                                <FormLabel
                                  className={classes.paddingBottom}
                                  component="label"
                                >
                                  Opis
                                </FormLabel>
                                <Typography>
                                  {document.description
                                    ? document.description
                                    : "-"}
                                </Typography>
                              </Grid>
                              <Grid item xs>
                                <FormControl
                                  fullWidth
                                  className={classes.formcontrol}
                                  variant="outlined"
                                >
                                  <FormLabel
                                    className={classes.paddingBottom}
                                    component="label"
                                  >
                                    Kto i kiedy utworzył
                                  </FormLabel>
                                  <Box>
                                    {!document ? (
                                      <Skeleton />
                                    ) : (
                                      <UserAndDate
                                        username={document.createdBy}
                                        date={document.createdAt}
                                        separator=", "
                                      />
                                    )}
                                  </Box>
                                </FormControl>
                              </Grid>
                              <Grid item xs>
                                <FormControl
                                  fullWidth
                                  className={classes.formcontrol}
                                  variant="outlined"
                                >
                                  <FormLabel
                                    className={classes.paddingBottom}
                                    component="label"
                                  >
                                    Kto i kiedy modyfikował
                                  </FormLabel>
                                  <Box>
                                    {!document ? (
                                      <Skeleton />
                                    ) : (
                                      <UserAndDate
                                        username={document.updatedBy}
                                        date={document.updatedAt}
                                        separator=", "
                                      />
                                    )}
                                  </Box>
                                </FormControl>
                              </Grid>
                            </Grid>
                          </AccordionDetails>
                        </Accordion>
                      ))
                    )}
                  </FormControl>
                </Box>
              ) : (
                <></>
              )}
              <Box className={classes.paddingtop}>
                <Button
                  disabled={saving}
                  color="primary"
                  className={classes.button}
                  component={RouterLink}
                  to={
                    parentFolderId
                      ? `/dokumenty/${parentFolderId}/`
                      : documentData?.parentFolderId
                      ? `/dokumenty/${documentData.parentFolderId}/`
                      : `/dokumenty`
                  }
                >
                  Anuluj
                </Button>
                <Button
                  disabled={saving}
                  color="primary"
                  variant="contained"
                  className={classes.button}
                  endIcon={<SaveIcon />}
                  type="submit"
                >
                  Zapisz
                </Button>
              </Box>
            </form>
          </Grid>
        </Grid>
      </Box>
    </Card>
  );
};

const mapDispatchToProps = (dispatch) => ({
  setLogoutUser: () => dispatch(actions.setLogoutUser()),
  enableGlobalLoader: () => dispatch(actions.enableGlobalLoader()),
  disableGlobalLoader: () => dispatch(actions.disableGlobalLoader()),
  displaySnackbar: (snackBarParameters) =>
    dispatch(actions.displaySnackbar(snackBarParameters)),
});

export default connect(null, mapDispatchToProps)(DocumentForm);
